import React from "react";

interface MetricBarProps {
    actual: number;
    target: number;
    bar: string;
    frac: number;
    height: string;
}

export const MetricBar: React.FC<MetricBarProps> = ({
    actual,
    target,
    bar,
    frac,
    height,
}) => {
    const denom = Math.max(1, target);
    const fillPct = Math.min(100, (actual / denom) * 100);
    const markerPct = Math.min(100, frac * 100);
    return (
        <div
            className={`relative w-full ${height} overflow-hidden rounded-full bg-zinc-200`}>
            <div
                className={`h-full ${bar} rounded-full`}
                style={{ width: `${fillPct}%` }}
            />
            {frac > 0 && frac < 1 ? (
                <span
                    className="absolute inset-y-0 w-0.5 bg-zinc-600/70"
                    style={{ left: `${markerPct}%` }}
                    title={`Expected pace (~${Math.round(frac * 100)}% through the month)`}
                />
            ) : null}
        </div>
    );
};
